import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { label: 'Hours Tracked', value: '420k+', sub: 'Real effort documented' },
  { label: 'Elite Builders', value: '18k', sub: 'Verified professionals' },
  { label: 'Project Artifacts', value: '1.2M', sub: 'Shared knowledge' },
  { label: 'Countries', value: '142', sub: 'Global movement' }
];

export default function StatsSection() {
  return (
    <section className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="text-center group"
            >
              <div className="text-5xl lg:text-7xl font-black text-white tracking-tighter italic uppercase mb-2 group-hover:text-indigo-400 transition-colors">
                {stat.value}
              </div>
              <div className="text-xs font-black text-white uppercase tracking-widest mb-1">{stat.label}</div>
              <div className="text-[10px] font-bold text-slate-600 uppercase tracking-widest">{stat.sub}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}